import React, { Fragment, useEffect, useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { routes } from './Routes';
import AppLayout from '../Layout/Layout';
import { getCurrentSubscription } from '../api-handle/merchantSubscriptionApi';
import { toast } from 'react-toastify';

const ProtectedRoute = ({ children, currentSubscription }) => {
  if (currentSubscription) return children;
  return <Navigate to="/subscriptions/my-subscriptions" replace />;
};

const LayoutRoutes = () => {
  const [currentSubscription, setCurrentSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch current subscription once
  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const res = await getCurrentSubscription();
        setCurrentSubscription(res.subscription || null);
      } catch (error) {
        console.error('Error fetching subscription:', error.message);
        setCurrentSubscription(null);
        // Don't show error toast for pending merchants or when subscription is simply not found
        // These are expected scenarios, not actual errors
        const errorMessage = error?.message || error?.error?.message || '';
        const isExpectedError = 
          errorMessage.includes('Merchant not approved') ||
          errorMessage.includes('not approved') ||
          error?.statusCode === 401;
        
        if (!isExpectedError) {
          toast.error('Failed to fetch subscription');
        }
      } finally {
        setLoading(false);
      }
    };
    fetchSubscription();
  }, []);

  if (loading) return null; // or a spinner

  return (
    <Routes>
      {routes.map(({ path, Component }, i) => {
        // Allow My-Subscriptions page without subscription
        const isMySubscriptionPage = path.includes('subscriptions/my-subscriptions');

        return (
          <Fragment key={i}>
            <Route element={<AppLayout />}>
              <Route
                path={path}
                element={
                  isMySubscriptionPage ? (
                    Component
                  ) : (
                    <ProtectedRoute currentSubscription={currentSubscription}>
                      {Component}
                    </ProtectedRoute>
                  )
                }
              />
            </Route>
          </Fragment>
        );
      })}
    </Routes>
  );
};

export default LayoutRoutes;
